import { SearchType } from 'search/SearchContext';
import SearchPageFactory from 'search/pages/SearchPageFactory';

const { SearchPageWithApollo } = SearchPageFactory({ type: SearchType.ToRent });

export default SearchPageWithApollo;
